var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.28 68.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "61.62 56.84 66.78 54.96 66.78 1.5 45.02 9.46 23.26 1.5 1.5 9.46 1.5 62.91 23.26 54.96 45.02 62.91 54.45 59.48"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.55,
    cy: 35.87,
    r: 12.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.43,
    y1: 47.33,
    x2: 54.14,
    y2: 51.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.06,
    y: 51.25,
    width: 6.75,
    height: 15.51,
    transform: "translate(-22.04 38.49) rotate(-30.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.15,
    y: 8.63,
    width: 2.87,
    height: 2.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.32,
    y: 16.24,
    width: 2.87,
    height: 2.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.76,
    y: 13.06,
    width: 2.87,
    height: 2.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 42.52,
    width: 2.87,
    height: 2.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.1,
    y: 32,
    width: 5,
    height: 4.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.24,36.8c3.44-.66,4.46-6.55,7.86-9,2.94-2.13,6.71-.66,8.34-5.08,1.06-2.85-2-7.64.17-9.82,1.69-1.74,7.85,1.8,8.51-3.11.46-3.44,9,1.64,8-.33a15.08,15.08,0,0,1-.82-3.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,57c3.54-3.08,4-10.43,7.91-9.8,1.87.3,3.93,3.51,7,1.28,1.26-.91,4.65,2.74,7.34,4.53,2.08,1.39,3.78,7.3,3.78,7.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCard2);
export default __webpack_public_path__ + "static/media/homeCard2.4aa4b755e7162f069decbed7052c6400.svg";
export { ForwardRef as ReactComponent };